<template>
  <div>
    <div class="vuemenu navigation">
      <slot></slot>
    </div>
    <div>
      <div id="griBlockMenuLeft" class="grid-block app-block zone collapse medium-3 large-2 vertical style-scope tpl-dashboard">
        <div class="grid-content collapse shrink style-scope tpl-dashboard">
          <div class="leftbar-header general-padding-left-app color-primary shadow-primary-black style-scope tpl-dashboard">
            <a href="https://royalpag.com/#/dashboard" class="no-effect-link style-scope tpl-dashboard">
              <img class="logo-principal style-scope tpl-dashboard" src="https://royalpag.com/img/logo-transparent.png" alt="Royal Pag" width="132px">
              <!-- <img src="/img/icon-crown.png" width="29px"> -->
              <!-- <img class="logo-coroa" src="/img/logo_coroa.jpeg" alt="Royal Pag" width="56px" height="56px"> -->
              <div class="content-logo-coroa style-scope tpl-dashboard">
                <img class="logo-coroa style-scope tpl-dashboard" src="https://royalpag.com/img/icon-crown.png">
              </div>
            </a>
          </div>
        </div>
        <div class="grid-content leftbar-content-parent style-scope tpl-dashboard">
          <div class="leftbar-content style-scope tpl-dashboard">
            <!-- <h4>MENU <small class="useridhash" on-tap="useridhashShow">&nbsp;ID: [[_substrUid(user.uid)]]</small></h4> -->
            <app-menulist class="style-scope tpl-dashboard">
              <div class="menu-container style-scope app-menulist" data-tippy-content="Dados pessoais" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/user/profile">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-user style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Dados pessoais</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="ComprarCurso" tabindex="0">
                <a class="links style-scope app-menulist" href="#/dashboard/buy">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-money-check-alt style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Comprar Curso</span>
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Contas" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/user/accounts">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-money-check-alt style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Contas</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Comprar Fichas" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/buy">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-cart-plus style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Comprar Fichas</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Vender Fichas" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/sell">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-cart-arrow-down style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Vender Fichas</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Afiliados" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/afilliates">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-users style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Afiliados</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Histórico" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/history">
                  <div class="item active style-scope app-menulist">
                    <i class="fa fa-chart-line style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Histórico</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Serviços" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/admin/services/all">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-ticket-alt style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Serviços</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Pagamentos" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/admin/payments">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-dollar-sign style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Pagamentos</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Transações" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/admin/transactions">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-exchange-alt style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Transações</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <div class="menu-container style-scope app-menulist" data-tippy-content="Usuários" tabindex="0">
                <!-- <div class="highlight"></div> -->
                <a class="links style-scope app-menulist" href="#/dashboard/admin/users">
                  <div class="item style-scope app-menulist">
                    <i class="fa fa-user-friends style-scope app-menulist"></i>
                    <span class="labelItem style-scope app-menulist">Usuários123</span>
                    <!-- <template is="dom-if" if="{{item.coming}}"><span class="is_new badge main-action">BREVE</span></template>
                       <template is="dom-if" if="{{item.startHere}}">
                           <span class="coming badge main-action">Comece Aqui</span>
                       </template>
                       <template is="dom-if" if="{{item.is_new}}">
                           <span class="is_new badge main-action">Novo</span>
                       </template> -->
                  </div>
                </a>
              </div>
              <template is="dom-repeat" class="style-scope app-menulist"></template>
            </app-menulist>
            <div class="bottom-flow style-scope tpl-dashboard" data-tippy-content="Logout" tabindex="0">
              <button class="btn line white signout style-scope tpl-dashboard">
                <i class="fas fa-door-closed style-scope tpl-dashboard"></i>&nbsp;<span class="style-scope tpl-dashboard">Logout123</span>
              </button>
              <div class="footers-links style-scope tpl-dashboard">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    computed: {
      $collapseItems () {
        return this.$children.filter(child => child._isCollapseItem)
      }
    },
    methods: {
      openByIndex (index) {
        this.$collapseItems.forEach((item, i) => {
          if (i !== index) {
            item.isActived = false
          }
        })
      }
    },
    mounted () {
      this.$on('closeall', (index) => {
        this.openByIndex(index)
      })
    }
  }
</script>
<style scoped>
  /* default styles
  * if you want to change this make changes
  * into file.css in the global scope.
  * e.g:
  *    div.app-menulist { padding: 0}
  */
  div.menu-container {
    position: relative;
    padding: 0;
    color: rgba(0,0,0, .70);
    /* border-bottom: 1px solid rgba(249,249,249,0.1); */
    cursor: pointer;
  }
  div.menu-container.dark {
    color: rgba(255,255,255,.70);
  }
  div.menu-container:hover {
    background: rgba(0,0,0,0.1);
  }
  div.menu-container .highlight {
    display: block;
    float: left;
    height: 45px;
    width: 8px;
  }
  div.menu-container:hover .highlight {
    background: white;
  }
  div.menu-container .item {
    font-size: 0.85em;
  }
  div.item {
    display: block;
    height: 45px;
    padding-top: 12px;
    padding-left: 15px;
    color: aliceblue;
    opacity: 0.87;
  }
  div.item span {
    margin-left: 6px;
    margin-right: 4px;
  }
  .links {
    font-weight: normal;
  }

  nav .brand-logo,nav ul a{
    color:#444
  }
  p{
    line-height:2rem
  }
  .button-collapse{
    color:#26a69a
  }
  .parallax-container{
    min-height:380px;
    line-height:0;
    height:auto;
    color:rgba(255,255,255,.9)
  }
  .parallax-container .section{
    width:100%
  }
  @media only screen and (min-width :998px){
    #player{
      height:320px
    }
  }
  @media only screen and (max-width :992px){
    .parallax-container .section{
      position:absolute;
      top:40%
    }
    #index-banner .section{
      top:10%
    }
    #player{
      height:320px
    }
  }
  @media only screen and (max-width :760px){
    .japa.jp-chamada001,.japa.jp-subtitle{
      background-color:rgba(255,255,255,.7)
    }
    .japa.jp-chamada001{
      padding-top:10px;
      padding-bottom:10px
    }
    .japa.jp-subtitle{
      color:#000
    }
  }
  @media only screen and (max-width :600px){
    #index-banner .section{
      top:0
    }
    #player{
      width:320px;
      height:200px
    }
  }
  .icon-block{
    padding:0 15px
  }
  .icon-block .material-icons{
    font-size:inherit
  }
  footer.page-footer{
    margin:0
  }
  .jp-text-color-default{
    color:#002157!important
  }
  .japa{
    font-size:1em;
    color:rgba(0,0,0,.86)
  }
  .japa .jp-color-2,.jp-color-2{
    color:rgba(0,0,0,.54)
  }
  .japa.jp-top{
    background-color:#002157;
    padding:4px 0
  }
  .japa.jp-link{
    text-align:right;
    font-size:.85em;
    color:#FFF;
    font-weight:300
  }
  .japa.jp-link span{
    margin-left:30px
  }
  .japa.jp-link span a{
    color:#fff
  }
  .japa.jp-chamada001{
    color:#234c89;
    text-transform:uppercase;
    font-size:21px;
    line-height:26px;
    font-style:italic;
    margin-right:0;
    padding-right:0
  }
  .japa.jp-chamada001 span{
    margin-top:10px
  }
  .japa.jp-header-text{
    opacity:0
  }
  .japa.jp-subtitle{
    color:#727376;
    font-size:1.2em;
    line-height:1.22em;
    font-weight:300;
    margin-top:0;
    margin-right:0;
    padding-right:0
  }
  .japa.jp-howwork{
    background-color:#234c89
  }
  .japa.jp-calculadora{
    min-height:400px;
    background-color:#fff
  }
  .japa.jp-calculadora h4{
    color:rgba(0,0,0,.86)
  }
  .calc-place{
    padding-top:55px
  }
  .japa.jp-calculadora .dropdown-content li>a,.japa.jp-calculadora .dropdown-content li>span,.japa.jp-calculadora .input-field{
    color:#234c89
  }
  .japa.jp-img,.jp-img{
    width:100%
  }
  p.jp-line-height{
    line-height:1.5rem
  }
  .jp-header-no-left{
    padding-left:0!important;
    margin-left:0!important
  }
  .jp-payments{
    background-color:#d7d7d7;
    color:#505050
  }
  .jp-footer,.jp-footer a{
    color:#002157
  }
  .jp-footer{
    background-color:#FFF!important
  }
  .jp-copyright{
    background-color:#fff!important;
    color:rgba(0,0,0,.54)
  }
  .jp-funcionamento,.jp-whowis{
    background-color:#234c89;
    color:#fff
  }
  .jp-contact{
    background-color:#c2c2c2
  }
  .jp-contact h4{
    color:rgba(0,0,0,.86)
  }
  .parallax-container.jp-parallax-top{
    min-height:500px
  }
  .jp-quemsomos{
    min-height:540px
  }
  .button-collapse.jp-btn-collapse{
    color:#234c89
  }
  .input-field .prefix.active,.input-field input[type=number]:focus+label,.input-field input[type=text]:focus+label,.input-field label,.input-field textarea:focus+label{
    color:#004185
  }
  .parallax-container .section.jp-section-to-quemsomos{
    top:0
  }
  .input-field input[type=number].invalid,.input-field input[type=number].valid,.input-field input[type=number]:focus,.input-field input[type=text].invalid,.input-field input[type=text].valid,.input-field input[type=text]:focus,.input-field textarea.invalid,.input-field textarea.valid,.input-field textarea:focus{
    border-bottom:1px solid black;
    box-shadow:0 1px 0 0 black;
  }
  .japa.jp-calculadora .input-field .values_chips_money{
    -webkit-transform:translateY(-140%);
    transform:translateY(-140%)
  }
  .placeholdervideo{
    color:#fff;
    display:block;
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    text-align:center
  }
  .jp-video{
    position:relative
  }
  .jp-video-overlay{
    position:fixed;
    top:0;
    left:0;
    width:100%;
    height:100%;
    background:rgba(0,0,0,.54);
    display:none
  }
  #player{
    margin:0 auto
  }
  #download-button{
    z-index:0
  }

  /** **/
  .grid-content { overflow-y: auto; }

  .menuleft .grid-block.app-block.zone {
    /* background-color: #2f5890; */
    background-color: #4a148c;
  }
  .menuleft .grid-block.app-block.zone.collapse.showSpan {
    min-width: 250px;
  }
  .menuleft .grid-block.app-block.zone.collapse {
    /* width: 80px; */
    min-width: 80px;
  }
  .menuleft .leftbar-header.general-padding-left-app {
    /* padding: 8px; */
    padding: 1px;
    background-color: #2f5890;
    height: auto;
  }
  .leftbar-header.general-padding-left-app img {
    display: block;
    margin: 0 auto;
  }
  .leftbar-header.general-padding-left-app .content-logo-coroa .logo-coroa {
    margin-top: 9px;
    margin-left: 6px;
    height: 48px;
  }
  .leftbar-header.general-padding-left-app .content-logo-coroa .logo-coroa {
    background-color: #fff;
    border-radius: 4px;
    padding: 10px 13px 11px 13px;
    height: 39px;
    margin: 9px auto;
  }
  .menuleft .showSpan .leftbar-header.general-padding-left-app .logo-principal,
  .menuleft .leftbar-header.general-padding-left-app .content-logo-coroa .logo-coroa {
    display: block;
  }
  .menuleft .leftbar-header.general-padding-left-app .logo-principal,
  .menuleft .showSpan .leftbar-header.general-padding-left-app .content-logo-coroa .logo-coroa {
    display: none;
  }

  .menuleft .leftbar-content-parent {
    /* width: 80px; */
    text-align: center;
    box-shadow: 0 0 3px #e6e6e6;
  }

  .menuleft .leftbar-content-parent .page-ds-user-profile {
    position: relative;
    display: inline-block;
    overflow: hidden;
    margin: 20px 0;
  }

  .menuleft .leftbar-content-parent .page-ds-user-profile .username {
    color: rgb(33, 150, 243);
  }

  .menuleft .leftbar-content-parent .page-ds-user-profile #photo {
    width: 100%;
  }

  .menuleft .leftbar-content-parent .leftbar-content {
    /* width: 80px; */
    /* padding-left: 8px; */
  }

  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist {
    text-align: center;
    border-top: 1px solid #e8e6e6;
    width: 100%;
  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist:hover {
    background: none;
  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist.active {
    color: rgb(49, 75, 136);
    background-color: #eeeeee;
  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist:hover {
    color: #f6b428;
    background-color: #4a148c;

  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist {
    height: auto;
    padding: 16px 0;
    color: #fff;
  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist i {
    font-size: 1.45em;
  }
  .menuleft .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist span {
    text-align: center;
    /* display: block; */
    display: none;
    font-size: 0.85em;
    margin-top: 5px;
    font-weight: bold;
  }
  .menuleft .showSpan .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist span {
    text-align: center;
    display: block;
    font-size: 0.85em;
    margin-top: 5px;
    font-weight: bold;
  }

  .menuleft .showSpan .leftbar-content-parent .leftbar-content span {
    display: block;
  }

  .labelshowHideLeftBar {
    position: absolute;
    top: 25%;
    /* margin-top: 8px; */
    margin-left: 32px;
    font-size: 1.55em;
    cursor: pointer;
    z-index: 99999;
  }

  .labelshowHideLeftBar i {
    color: #333;
  }

  .labelshowHideLeftBar a:hover {
    text-decoration: none;
    border-bottom: none;
    opacity: 0.7;
  }

  .menuleft .titles {
    margin-left: 19px !important;
  }
  .menuleft div.item.app-menulist {
    opacity: 1;
  }

  /** titles **/
  .menuleft .titles .button-icon { display: none; }

  /** logout **/
  .menuleft .bottom-flow {
    margin-top: 0px !important;
    border-top: 1px solid #fff;
  }
  .menuleft .bottom-flow:hover {
    background-color: #4a148c;
    color: #f6b428;
    cursor: pointer;
  }
  .menuleft .bottom-flow button.btn {
    margin-top: 10px;
    color: #fff;
    border: none;
    /* border: 1px solid transparent; */
    border-color: transparent;
    background: none !important;
  }
  .menuleft .bottom-flow:hover button.btn {
    color: #f6b428;
  }
  .menuleft .bottom-flow button.btn span {
    display: none;
  }
  .menuleft .bottom-flow button.btn,
  .menuleft .bottom-flow button.btn:hover  {
    /* border: 1px solid rgba(255,255,255,0.70);
    border-color: rgba(255,255,255,0.12); */
    border: none !important;
    border-color: transparent !important;
    background: none !important;
  }
  .menuleft .showSpan .bottom-flow button.btn span {
    font-size: 1.15em;
    margin-top: 5px;
    font-weight: bold;
    display: block;
    text-align: center;
  }
  .menuleft .bottom-flow button.btn i {
    font-size: 1.45em;
  }

  /** Media queries **/
  @media screen and (max-width: 690px) {
    .labelshowHideLeftBar {
      top: 30%;
      /* margin-left: 72px; */
    }
    .labelshowHideLeftBar i {
      color: #fff !important;
    }

    #griBlockMenuLeft {
      display: block !important;
      min-width: 80px;
    }
    .menuleft .leftbar-content-parent .leftbar-content.showSpan span {
      display: none !important;
    }

    .menuleft .leftbar-header.general-padding-left-app .logo-principal {
      display: none !important;
    }
    .menuleft .leftbar-header.general-padding-left-app .content-logo-coroa .logo-coroa {
      display: block !important;
    }
    .menuleft .leftbar-header.general-padding-left-app .logo-crown {
      display: block !important;
    }
    .menuleft .bottom-flow button.btn,
    .menuleft .bottom-flow button.btn:hover  {
      /*border: transparent !important;
      border-color: transparent !important;
      background: none !important; */
      border: none !important;
      border-color: transparent !important;
      background: none !important;
    }
    .menuleft .bottom-flow button.btn span {
      display: none !important;
    }
    .menuleft .showSpan .bottom-flow button.btn span {
      display: none !important;
    }
    .leftbar-content-parent .leftbar-content .menu-container.app-menulist .item.app-menulist span {
      display: none !important;
    }
  }


</style>



// WEBPACK FOOTER //
// menu.vue?1fdd122f